module.exports = __webpack_public_path__ + "static/media/IMG-20230508-WA0173.cb149ff2.jpg";